import { addDoc } from "firebase/firestore";

export const addToHistory = async (historyRef, description) => {
  await addDoc(historyRef, {
    date: new Date(),
    description: description,
  });
  return 'History added successfully';
};